import { types } from '../actions/MusicActions';
import audioClipartModel from '../components/utils/AudioClipartModel';

export function addSoundClipartModel (state, clipartModel) {
    return Object.assign({}, state, {
        soundClipartModel: clipartModel
    });
}

export default function(state = {}, action) {

    switch (action.type) {

        case types.CHANGE_MAIN_AUDIO_CATEGORY_INDEX: {
            var subcategoryIndex = audioClipartModel.subcategories[action.index];
            return Object.assign({}, state, {mainAudioCategoryIndex: action.index, secondAudioCategoryIndex: subcategoryIndex});
        }

        case types.CHANGE_SOUND_EFFECTS_CATEGORY_INDEX: {
            return Object.assign({}, state, {soundEffectsCategoryIndex: action.index});
        }

        case types.CHANGE_SECOND_AUDIO_CATEGORY_INDEX: {
            audioClipartModel.subcategories[state.mainAudioCategoryIndex] = action.index;
            return Object.assign({}, state, {secondAudioCategoryIndex: action.index});
        }

        case types.ADD_SOUND_CLIPART_MODEL: {
            return addSoundClipartModel(state, action.clipartModel);
        }

        case types.CHANGE_MUSIC_CONTENT_INDEX: {
            return Object.assign({}, state, {musicContentIndex: action.index});
        }

        case types.CHANGE_SLIDE_AUDIO_INDEX: {
            return Object.assign({}, state, {slideAudioIndex: action.index});
        }

        default:
            return state;
    }
}



/** WEBPACK FOOTER **
 ** ./src/reducers/MusicReducer.js
 **/